import { Component, Input, OnInit } from '@angular/core';
import { IntegrationType, RecipeTemplate } from '@pdqdev/pdq-shared/dist/entities/Integrations';

@Component({
  selector: 'recipe-templates',
  templateUrl: './recipe-templates.component.html',
  styleUrls: ['./recipe-templates.component.scss'],
  standalone: false,
})
export class RecipeTemplatesComponent implements OnInit {
  @Input() recipeTemplates: RecipeTemplate[];
  @Input() integrationType: IntegrationType;
  constructor() {}

  ngOnInit(): void {}
}
